module.exports = __webpack_public_path__ + "media/images/red_minus-b64ea29e6afa0279cf6cb105c851db2b.svg";